export enum EXPERIENCE_AVAILABLE_DAY_LIMIT {
  CHECK_IN = 'CHECK_IN',
  MID_STAY = 'MID_STAY',
  CHECK_OUT = 'CHECK_OUT',
}

export const DEFAULT_EXPERIENCE_AVAILABLE_DAY_LIMIT = Object.values(
  EXPERIENCE_AVAILABLE_DAY_LIMIT
);

export type ExperienceAvailableDayLimit =
  (typeof EXPERIENCE_AVAILABLE_DAY_LIMIT)[keyof typeof EXPERIENCE_AVAILABLE_DAY_LIMIT];
